import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';

import {UserModule} from '../user/user.module';

import {PayrollSerieListComponent} from './payroll-serie-list.component';
import {UiModule} from '../ui/ui.module';

@NgModule({
    imports: [
        CommonModule,
        UserModule,
        RouterModule,
        TranslateModule,
        UiModule
    ],
  declarations: [
    PayrollSerieListComponent
  ],
  exports: [
    PayrollSerieListComponent
  ]
})

export class PayrollSerieListModule {
}
